import { useSyncExternalStore } from "react";
import gpsTracker from "./gpsTracker";

// This device's GPS tracker state for React screens. The tracker itself lives
// outside React (gpsTracker.js), so it keeps running across page changes; every
// screen that calls this hook sees the same state.
export default function useTspGpsTracker(tracker = gpsTracker) {
  const state = useSyncExternalStore(tracker.subscribe, tracker.getState, tracker.getState);
  return { state, tracker };
}
